import { LocalStorageKeys } from '../constants/locationStorage';

export const localStorageCleanUp = () => {
  localStorage.removeItem(LocalStorageKeys.TOKEN);
  localStorage.removeItem(LocalStorageKeys.PROFILE);
  localStorage.removeItem(LocalStorageKeys.IS_AUTHENTICATED);
  localStorage.removeItem(LocalStorageKeys.POST_LOGIN_REDIRECT);
};

export const getApiBaseUrl = () => {
  const configuredApiBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim();

  if (configuredApiBaseUrl) {
    return configuredApiBaseUrl;
  }

  if (
    typeof window !== 'undefined' &&
    window.location.hostname === 'localhost'
  ) {
    return '/api';
  }

  return '/api';
};

export const getApiKey = () => import.meta.env.VITE_API_KEY;
